export const generatePageTitle = (title: string) => {
  return title + " - iData Online";
};
